var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSibaddon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "sib_addon_svg__Calque_1",
  x: 0,
  y: 0,
  viewBox: "0 0 27.2 27.2"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".sib_addon_svg__st1{fill:red}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21 .8H6.1C3.2.8.8 3.2.8 6.1V21c0 2.9 2.4 5.3 5.3 5.3H21c2.9 0 5.3-2.4 5.3-5.3V6.1c0-2.9-2.4-5.3-5.3-5.3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.1.8C3.2.8.8 3.2.8 6.1v7.8l5.9-2.4c0-1.1.8-2 1.8-2.3L9.9.7H6.1z",
  className: "sib_addon_svg__st1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 .8h-9l-1.4 8.8c.7.4 1.1 1.2 1.1 2.1v.1l7.6 4.3c.4-.3 1-.5 1.5-.5 1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5v-.2l-7.6-4.3c-.4.3-1 .6-1.6.6-.7 0-1.3-.3-1.7-.7L.7 16.1V21c0 2.9 2.4 5.3 5.3 5.3h15c2.9 0 5.3-2.4 5.3-5.3V6.1c0-2.9-2.4-5.3-5.3-5.3",
  className: "sib_addon_svg__st1"
})));
export default SvgSibaddon;